export class LibertyAvDLE {
    constructor(socket, log) {
        this.socket = socket;
        this.firmwareVersion = '1.0.1';
        this.power = false;
        this.presets = [];
        this.videoOutputs = [];
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /\^Version/,
                callback: (match) => {
                    this.socket.send(`V${this.firmwareVersion}`);
                },
            },
            {
                name: 'getRoute',
                regExp: /STA_VIDEO/,
                callback: (match) => {
                    this.videoOutputs.forEach((videoOutput, i) => {
                        this.socket.send(`Output${i + 1} Switch To ${videoOutput.padStart(2, '0')}!`);
                    });
                },
            },
            {
                name: 'setRoute',
                regExp: /OUT(\d+):(\d+)/,
                callback: (match) => {
                    const output = parseInt(match[1], 10);
                    this.videoOutputs[output - 1] = match[2];
                    this.socket.send(`Output${match[1]} Switch To ${match[2].padStart(2, '0')}!`);
                },
            },
            {
                name: 'setRouteAll',
                regExp: /(\d+)ALL/,
                callback: (match) => {
                    this.videoOutputs.forEach((videoOutput, i) => {
                        this.videoOutputs[i + 1] = match[1];
                        this.socket.send(`Output${i + 1} Switch To ${match[1].padStart(2, '0')}!`);
                    });
                },
            },
            {
                name: 'powerSet',
                regExp: /Power(ON|OFF)/,
                callback: (match) => {
                    this.power = match[1].toUpperCase() === 'ON' ? true : false;
                    this.socket.send(this.power ? 'Power ON!' : 'Power OFF!');
                },
            },
            {
                name: 'presetQuery',
                regExp: /PresetSta(\d+)/,
                callback: (match) => {
                    const presetNum = parseInt(match[1], 10);
                    const preset = this.presets[presetNum - 1];
                    this.socket.send(`Preset${match[1]} Sta:`);
                    if (presetNum <= 6) {
                        this.videoOutputs.forEach((videoOutput, i) => {
                            this.socket.send(`Out${i + 1} In ${preset[i].padStart(2, '0')}!`);
                        });
                    }
                },
            },
            {
                name: 'presetRecall',
                regExp: /PresetRecall(\d+)/,
                callback: (match) => {
                    const presetNum = parseInt(match[1], 10);
                    const preset = this.presets[presetNum - 1];
                    this.socket.send(`Preset${match[1]} Recall:`);
                    if (presetNum <= 6) {
                        this.videoOutputs.forEach((videoOutput, i) => {
                            this.videoOutputs[i] = preset[i];
                            this.socket.send(`Output${i + 1} Switch To ${preset[i].padStart(2, '0')}!`);
                        });
                    }
                },
            },
            {
                name: 'presetSave',
                regExp: /PresetSave(\d+)/,
                callback: (match) => {
                    const presetNum = parseInt(match[1], 10);
                    const preset = this.presets[presetNum - 1];
                    if (presetNum <= 6) {
                        this.videoOutputs.forEach((videoOutput, i) => {
                            preset[i] = videoOutput;
                        });
                    }
                    this.socket.send(`Preset${match[1]} Save Success!`);
                },
            },
            // The documentation doesn't describe the power get feature. I'm assuming it's part
            // STA status command.
            {
                name: 'Status',
                regExp: /STA/,
                callback: (match) => {
                    this.getStatusResponse().forEach(resp => this.socket.send(resp));
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`CMD Error!`);
                },
            },
        ];
        this.commandExtractor = {
            terminators: ['.'],
        };
        this.sendTerminator = '\r\n';
    }
    onConfigure(config) {
        var _a;
        const numOutputs = Object.keys((_a = config === null || config === void 0 ? void 0 : config.videoOutputs) !== null && _a !== void 0 ? _a : {}).length;
        this.videoOutputs = Array(numOutputs).fill('1');
        this.presets = Array(6).fill(Array(numOutputs).fill('1'));
    }
    getStatusResponse() {
        const response = [];
        response.push('GUI Or RS232 Query Status:');
        response.push(`${this.videoOutputs.length}x${this.videoOutputs.length} HDBT Matrix`);
        response.push(`DL-${this.videoOutputs.length}${this.videoOutputs.length}E-H2`);
        response.push(`${this.firmwareVersion}`);
        response.push(`Power ${this.power ? 'ON' : 'OFF'}!`);
        response.push('Front Panel UnLock!');
        response.push('DIP0000!');
        response.push('EDID_RS232&GUI&IR_MODE!');
        response.push('Local RS232 Baudrate Is 9600!');
        response.push('GUI_IP:192.168.0.172!');
        response.push('HDBT1 Power ON!');
        response.push('HDBT2 Power ON!');
        response.push('HDBT3 Power ON!');
        response.push('SPDIF Out ON!');
        response.push('IIS Out ON!');
        this.videoOutputs.forEach((videoOutput, i) => {
            response.push(`Output${i + 1} Switch to ${videoOutput.padStart(2, '0')}!`);
        });
        response.push('IR Follow Video ON!');
        response.push('Local1 IR Out Swtich To Remote1 IR IN!');
        response.push('Local2 IR Out Swtich To Remote2 IR IN!');
        response.push('Local3 IR Out Swtich To Remote3 IR IN!');
        response.push('IN    01 02 03 04');
        response.push('Link  Y  Y  Y  N');
        response.push('OUT    01 02 03 04');
        response.push('Link  Y  Y  Y  N');
        this.videoOutputs.forEach((videoOutput, i) => {
            response.push(`OUT 0${i + 1} HDCP ON!`);
        });
        return response;
    }
}
LibertyAvDLE.emulatorType = 'socketEmulator';
LibertyAvDLE.key = '-MUtghIHOu29nO4Zvavf';
